import React from "react";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import EstadoVazioTabela from "../Table/estadoVazio";

interface Props {
  colunas: number;
  titulo?: string;
  apoio?: string;
}

const LinhaSemRegistros = ({ colunas, titulo, apoio }: Props) => (
  <TableBody>
    <TableRow>
      <TableCell colSpan={colunas} align="center" style={{ borderBottom: "none" }}>
        <EstadoVazioTabela compacto titulo={titulo} apoio={apoio} />
      </TableCell>
    </TableRow>
  </TableBody>
);

export default LinhaSemRegistros;
